module.exports = __webpack_public_path__ + "img/mockup.837118fa.png";